"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LoadingButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const Button_1 = __importDefault(require("../components/Button"));
function LoadingButton(props) {
    const [loading, setLoading] = react_1.default.useState(false);
    const THEME = (0, ThemeContext_1.useTheme)();
    const load = react_1.default.useCallback(async () => {
        setLoading(true);
        try {
            var data = await props.onLoad();
            await props.onDone(data);
        }
        catch (error) {
            await props.onError(data);
        }
        finally {
            setLoading(false);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": props["aria-label"], accessibilityHint: props.accessibilityHint, disabled: loading, onPress: load, type: props.type, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginVertical: 2,
                    opacity: loading ? 0 : 1
                }, children: props.children }), loading &&
                (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Primary, size: "small", style: { position: 'absolute', height: 8 } })] }));
}
;
